import * as shvl from 'shvl'

export default (arr, fieldKey, numeric = false) => {
  if (arr && arr.length && fieldKey) {
    return arr.reduce((obj, row) => {
      const propertyValue = shvl.get(row, fieldKey, null)
      if (propertyValue) {
        const rowValue = numeric ? parseInt(propertyValue) : propertyValue
        if (rowValue !== undefined) {
          if (!Array.isArray(obj[rowValue])) {
            obj[rowValue] = []
          }
          obj[rowValue].push(row)
        }
      }
      return obj
    }, {})
  }
}
